<template>
  <div class="authorInfo">
    <triggernav
      :triggerval="triggerval"
      :titlevalue="titlevalue"
      v-if="!isShowChangeModify"
      @changeyours="changeyours"
      :isblue="true"
    ></triggernav>
    <div class="InfoWrap" v-if="!isShowChangeModify">
      <div class="normalbox" v-if="triggerval.chooseIndex == 0">
        <el-form
          ref="authorForm"
          :model="authorInfo"
          :rules="rules"
          label-position="left"
          label-width="100px"
        >
          <a
            v-for="item in userlist"
            :key="item.userId"
            href="javaScript:"
            class="seeChild"
            @click="isbindChild(item.userId)"
            ><span class="circlered"></span
            >{{ item.userName }}发起绑定申请，请确认操作</a
          >
          <el-form-item prop="mobile" label="手机号">
            <el-input
              v-model="authorInfo.mobile"
              placeholder="手机号"
              class="login-form-input"
              readonly
              ref="mobole"
            ></el-input>
          </el-form-item>
          <el-form-item prop="im" label="QQ">
            <el-input
              v-model="authorInfo.im"
              placeholder="QQ"
              class="login-form-input"
              ref="im"
            ></el-input>
          </el-form-item>
          <el-form-item prop="address" label="联系地址">
            <el-input
              v-model="authorInfo.address"
              placeholder="联系地址"
              class="login-form-input"
              ref="address"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="bind"
            label="子账户"
            style="text-align:left"
            v-if="passList.length > 0"
          >
            <div class="scrollbox" ref="bscroll">
              <div class="personTab" ref="personTab">
                <span v-for="item in passList" :key="item.userId">
                  {{ item.userName }}
                </span>
              </div>
            </div>
            <span class="bindhint">已绑定</span>
          </el-form-item>
          <el-form-item>
            <el-button
              class="usersub"
              size="medium"
              @click="submitapply('authorForm')"
              >确认修改</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="signInfo" v-if="triggerval.chooseIndex == 1">
        <template v-if="true">
          <writeList :booklist="booklist" :isSign="true"></writeList>
          <el-pagination
            v-if="totalPage / 14 > 1"
            background
            layout="prev, pager, next"
            :total="totalPage"
            class="paginnation-book"
            @current-change="currentChoose"
          >
          </el-pagination>
        </template>
      </div>
    </div>
    <div class="InfoWrap changeModify" v-if="isShowChangeModify">
      <h3>
        账户变更申请
        <a href="javaScript:" @click="goback()" class="writebook frr"
          >作者资料</a
        >
      </h3>
      <el-form
        ref="applyForm"
        :model="applyDate"
        :rules="applyrules"
        label-width="100px"
        v-if="isChangeModify"
        label-position="left"
        style="margin-top:24px"
      >
        <el-form-item label="真实笔名" class="isreadonly">
          <el-input
            readonly
            v-model="applyDate.realName"
            placeholder="真实笔名"
            class="login-form-input"
            ref="name"
          ></el-input>
        </el-form-item>
        <!--   <el-form-item label="证件类型" class="isreadonly">
          <el-input
            readonly
            v-model="applyDate.idNo"
            placeholder="证件类型"
            class="login-form-input"
            ref="adress"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="身份证号" class="isreadonly">
          <el-input
            v-model="applyDate.idNo"
            readonly
            placeholder="请输入真实的身份证号"
            class="login-form-input"
            ref="IDnumber"
          ></el-input>
        </el-form-item>
        <el-form-item prop="bank" label="开户行全称">
          <el-input
            v-model="applyDate.bank"
            placeholder="填写样式：招商银行 xx省xx市xx区xx支行"
            class="login-form-input"
            ref="bank"
          ></el-input>
        </el-form-item>
        <p class="hintblue">
          温馨提示：为了您能收到付款，请详细填写银行相关信息。开户行仅限于中国大陆银行，具体到
          支行，否则无法汇款不予结算（无法确认开户支行，请咨询您的开户行进行查询）
        </p>
        <el-form-item prop="account" label="银行账号">
          <el-input
            v-model="applyDate.account"
            placeholder="为了避免您的损失，请您务必填写银行账号！"
            class="login-form-input"
            ref="account"
          ></el-input>
        </el-form-item>
        <div class="signStutus" style="margin: 40px 0 20px">
          <span class="active">作家提交审核</span> > <span>责编审核</span> >
          <span>主编审核</span> > <span>待邮寄</span> > <span>签约完成</span>
        </div>

        <el-form-item>
          <el-button
            class="usersub"
            size="medium"
            @click="changeapply('applyForm')"
            >提交审核</el-button
          >
        </el-form-item>
        <p
          class="hint"
          style="margin-bottom:0px;line-height:16px;margin-top:10px;text-align:left;text-align:center;font-weight:600"
        >
          特别提示：请仔细核对账号信息，如有误，不予结算！
        </p>
      </el-form>
      <el-form
        ref="applyForm"
        :model="applyDate"
        v-if="!isChangeModify"
        :rules="applyrules"
        label-width="100px"
        label-position="left"
        style="margin-top:24px"
      >
        <el-form-item label="真实笔名" class="isreadonly">
          <el-input
            readonly
            v-model="applyDate.realName"
            placeholder="真实笔名"
            class="login-form-input"
            ref="name"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号" class="isreadonly">
          <el-input
            v-model="applyDate.idNo"
            readonly
            placeholder="请输入真实的身份证号"
            class="login-form-input"
            ref="IDnumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户行全称" class="isreadonly">
          <el-input
            v-model="applyDate.bank"
            readonly
            placeholder="填写样式：招商银行 xx省xx市xx区xx支行"
            class="login-form-input"
            ref="bank"
          ></el-input>
        </el-form-item>
        <el-form-item label="银行账号" class="isreadonly">
          <el-input
            v-model="applyDate.account"
            readonly
            placeholder="为了避免您的损失，请您务必填写银行账号！"
            class="login-form-input"
            ref="account"
          ></el-input>
        </el-form-item>
        <div class="signStutus">
          <span class="active">作家提交审核</span> > <span>责编审核</span> >
          <span>主编审核</span> > <span>待邮寄</span> > <span>签约完成</span>
        </div>
        <table>
          <tr>
            <th>审核人</th>
            <th>操作</th>
            <th>备注</th>
            <th></th>
          </tr>
          <tr>
            <td></td>
            <td style="color:rgba(9,178,26,1);">通过</td>
            <td style="color:rgba(92,92,92,1);">内部测试</td>
            <td style="color:rgba(136,136,136,1);">2019-07-03 14:43:12</td>
          </tr>
          <tr>
            <td></td>
            <td>通过</td>
            <td>内部测试</td>
            <td>2019-07-03 14:43:12</td>
          </tr>
          <tr>
            <td></td>
            <td>通过</td>
            <td>内部测试</td>
            <td>2019-07-03 14:43:12</td>
          </tr>
        </table>
      </el-form>
    </div>
    <surePop :ApplyInfo="ApplyInfo" @passbind="passbind"></surePop>
  </div>
</template>

<script>
import {
  signBookList,
  getNormalInfo,
  changeNormalInfo,
  isbindpass,
  ischangeMainId,
  changeMainId
} from "apiurl/author";
import { isQQ, decrypt, isAccount, encryptStr } from "utils/core/kernel";
import BScroll from "better-scroll";
export default {
  data() {
    var validateQQ = (rule, value, callback) => {
      if (isQQ(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的QQ"));
      }
    };
    /* 验证银行卡 */
    var isaccount = (rule, value, callback) => {
      if (isAccount(value)) {
        callback();
      } else {
        callback(new Error("请输入正确银行账号"));
      }
    };
    return {
      applyDate: {
        name: "",
        idNo: "",
        bank: "",
        account: null
      },
      authorInfo: {
        im: null,
        mobile: null,
        address: ""
      },
      rules: {
        im: [
          { required: true, message: "请输入QQ", trigger: "blur" },
          { validator: validateQQ, trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入你的住址", trigger: "blur" }
        ]
      },
      applyrules: {
        bank: [
          { required: true, message: "请输入银行账户全称", trigger: "blur" }
        ],
        account: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
          { validator: isaccount, trigger: "blur" }
        ]
      },
      checked: true,
      frontUrl: "",
      reverseUrl: "",
      triggerval: {
        chooseVal: ["作者信息", "签约信息"],
        chooseIndex: 0 // 切换信息：基本 签约
      },
      titlevalue: "申请变更账户信息",
      totalPage: 1,
      booklist: [], //书籍列表
      isShowChangeModify: false, //是否显示变更账户
      ApplyInfo: {
        isShow: false,
        title: "绑定申请",
        content: "申请绑定的用户昵称申请成为您的子账户，是否通过申请？",
        hint: "* 同意申请将有可能泄露您的隐私，一旦绑定无法撤销",
        sure: "通过",
        cancle: "驳回"
      },
      userlist: [], //带审核绑定用户的列表
      passList: [], //已绑定用户列表
      optionBindId: null, // 操作子账号的id
      isChangeModify: true
    };
  },
  created() {
    this.getwriteList(1);
    // 获取用户基本信息
    this.getInfo();
  },
  methods: {
    // 获取作者写书列表
    async getwriteList(pageNo) {
      let res = await signBookList({ pageSize: 14, pageNo: pageNo });
      if (res.success) {
        this.booklist = res.data.items;
        this.totalPage = Number(res.data.totalCount);
      }
    },
    // 滚动
    myscroll() {
      if (this.passList.length > 0) {
        this.$refs.personTab.style.width = 100 * this.passList.length + "px";
        this.$nextTick(() => {
          if (!this.scroll) {
            this.scroll = new BScroll(this.$refs.bscroll, {
              startX: 0,
              click: true,
              scrollX: true,
              scrollY: false,
              eventPassthrough: "vertical"
            });
          } else {
            this.scroll.refresh();
          }
        });
      }
    },
    // 获取用户基本信息
    async getInfo() {
      let info = await getNormalInfo();
      if (info.success) {
        this.authorInfo = {
          im: info.data.authorDto.qq,
          mobile: decrypt(info.data.authorDto.mobiel),
          address: info.data.authorDto.address
        };
        let list = info.data.waitRel;
        list.forEach(item => {
          this.userlist.push(item.objectVO);
        });
        info.data.passRel.forEach(item => {
          this.passList.push(item.objectVO);
        });
        this.$nextTick(() => {
          this.myscroll();
        });
      }
    },
    //下一页列表
    currentChoose(page) {
      this.getwriteList(page);
    },
    handleAvatarSuccess(res, file) {
      this.frontUrl = URL.createObjectURL(file.raw);
    },
    handlereverseSuccess(res, file) {
      this.reverseUrl = URL.createObjectURL(file.raw);
    },
    // 切换变更账户
    changeyours() {
      ischangeMainId()
        .then(res => {
          if (res.success) {
            let signinfo = JSON.parse(res.data.apply.content);
            this.applyDate.realName = signinfo.name;
            this.applyDate.idNo = decrypt(signinfo.idNo, 1);
            this.isShowChangeModify = true;
          }
        })
        .catch(() => {});
    },
    // 变更账户
    changeapply(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          changeMainId(
            this.qs.stringify({
              bank: this.applyDate.bank,
              account: encryptStr(this.applyDate.account)
            })
          )
            .then(res => {
              if (res.success) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
              }
            })
            .catch(() => {});
        }
      });
    },
    goback() {
      this.isShowChangeModify = false;
    },
    // 打开绑定
    isbindChild(id) {
      this.ApplyInfo.isShow = true;
      this.optionBindId = id;
    },
    /* 是否通过绑定 */
    passbind(bindvalue) {
      isbindpass(
        this.qs.stringify({
          pass: bindvalue,
          userId: this.optionBindId
        })
      )
        .then(res => {
          if (res.success) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.ApplyInfo.isShow = false;
            this.getInfo();
          }
        })
        .catch(() => {});
    },
    //更改作家基本信息
    submitapply(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          changeNormalInfo(
            this.qs.stringify({
              qq: this.authorInfo.im,
              address: this.authorInfo.address
            })
          )
            .then(res => {
              if (res.success) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
              }
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>
<style>
.authorInfo .el-form {
  padding: 0 170px 0 24px;
}
.authorInfo .el-form-item__content {
  text-align: center;
  line-height: 0px;
}
.InfoWrap .isreadonly .el-input__inner {
  background: #eee;
}
.InfoWrap .usersub.el-button {
  width: 124px;
  height: 34px;
  color: #fff;
  background: #48a2df;
  border: none;
  line-height: 15px;
}
.InfoWrap .login-form-input .el-input__inner {
  border-radius: 4px;
  height: 34px;
  font-family: PingFangSC-Regular;
}
.InfoWrap .bind .el-input__inner {
  padding-right: 55px;
}
.authorInfo .usersub.el-button span {
  vertical-align: top;
}
.authorInfo .usersub.el-button:focus {
  width: 124px;
  height: 34px;
  background: #48a2df;
  border-radius: 4px;
  border-color: #48a2df;
  color: #fff;
  height: 34px;
}
.authorInfo .bind .el-form-item__content {
  text-align: left;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding-left: 15px;
  color: #606266;
}
.authorInfo .usersub.el-button:hover {
  width: 124px;
  height: 34px;
  background: #48a2df;
  border-radius: 4px;
  border-color: #48a2df;
  color: #fff;
  height: 34px;
}
.InfoWrap .el-form-item__label {
  color: #333;
  font-size: 16px;
  height: 34px;
  line-height: 34px;
  font-family: PingFangSC-Regular;
}
.authorInfo .el-input-group {
  margin-bottom: 0px;
}
.InfoWrap .el-input-group__append {
  background: #48a2df;
  text-align: center;
  color: #fff;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;
}
.InfoWrap .el-input-group--append .el-input__inner {
  height: 34px;
  line-height: 34px;
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #fff;
  margin-right: 0px;
}
</style>

<style lang="stylus" scoped>
.scrollbox
    width 85%
    height 34px
    line-height 34px
    position relative
    overflow hidden
    .personTab
        height 34px
        line-height 34px
        span
            display inline-block
            height 34px
            line-height 34px
            width 200px
            overflow hidden
.authorInfo
    min-height 716px
    .bind
        .bindhint
            position absolute
            right 10px
            top 0
            bottom 0
            margin auto 0
            display inline-block
            line-height 34px
            color #4FC900
.InfoWrap
    .normalbox
        margin 24px 75px 24px 24px
    .seeChild
        font-size 12px
        display block
        font-family PingFangSC
        font-weight 600
        color rgba(255, 0, 0, 1)
        line-height 17px
        margin-bottom 15px
        .circlered
            width 10px
            height 10px
            background rgba(255, 0, 0, 1)
            display inline-block
            border-radius 50%
            margin-right 5px
.hint
    font-size 12px
    color rgba(248, 81, 81, 1)
    margin-bottom 24px
.hintblue
    font-size 12px
    color #25a5cf
    margin-bottom 24px
    line-height 20px
    padding 3px 15px
    background rgba(240, 248, 255, 1)
.imgbox
    margin 20px 0
    .uploader
        width 150px
        height 150px
        overflow hidden
        margin 0 40px 0 110px
        img
            width 150px
            height 150px
    .egfront
        img
            width 150px
            height 150px
        li
            font-size 12px
            line-height 24px
            color rgba(51, 51, 51, 1)
            margin-left 18px
.IDphoto
    padding 23px 25px
    border 1px solid rgba(211, 211, 211, 1)
    border-radius 4px
    img
        width 250px
        display inline-block
        height 120px
        &:first-child
            margin-right 20px
.signStutus
    text-align center
    font-size 14px
    color #5C5C5C
    margin-bottom 14px
    .active
        color #25A5CF
.changeModify
    table
        width 464px
        background rgba(240, 248, 255, 1)
        border-radius 4px
        font-size 12px
        border 1px solid rgba(218, 230, 241, 1)
        margin-left 100px
        margin-bottom 30px
        text-align center
        th
            color rgba(51, 51, 51, 1)
            height 32px
            line-height 32px
        td
            height 32px
            line-height 32px
.paginnation-book
    position absolute
    right 20px
    bottom 20px
</style>
